<template>
    <div id="contents" class="contents contents-other">
        <div class="breadcrumb">
            <ul>
                <li>
                    <router-link :to="{name: 'Index'}">TOP</router-link>
                </li>
                <li>Helpful Info</li>
            </ul>
        </div>

        <h1 class="ttl">Helpful Info</h1>

        <div class="box-section -grayBgStart">
            <div class="inner">
                <h2 class="ttl" id="goInfo">General Information</h2>

                <h3 class="ttlSub" id="the-climate-in-japan">The Climate in Japan</h3>
                <p class="para">
                    Japan has a varied climate with its many islands that extend from the subarctic island of Hokkaido in the north to the subtropical islands of Okinawa in the south. The country is also very mountainous with many mountain ranges, which means days with heavy rain and snowfall on the coastal areas by the Japan Sea, while the coastal areas alongside the Pacific Ocean may see warmer, sunnier weather more often. The rainy season typically runs for about a month and a half sometime between early May to the end of July, depending on the location. Most areas will experience a rise in rainfall with the exception of Hokkaido. If you are planning to travel during the rainy season, it is advisable that you bring rain gear with you. If you prefer not to bring an umbrella with you, they are sold at most convenience stores at an average price of 500 yen each. Some stores will also sell them at the shopfront when it starts to rain.<br>
                    <br>
                    In recent years, temperatures during the summer has become intensely hot in some areas. Please exercise extra caution when spending long hours outdoors.<br>
                    <br>
                    Tropical cyclones (typhoons) are common between the months of July and October, bringing heavy rainfall and strong winds.<br>
                    <br>
                    For more information on the weather where you are visiting, please go to:<br>
                    <a href="http://www.jnto.go.jp/weather/eng/index.php">http://www.jnto.go.jp/weather/eng/index.php</a>
                </p>

                <h3 class="ttlSub" id="traffic">Transportation</h3>

                <h4 class="ttlSubSub">Public Transport</h4>
                <p class="para">Trains and buses are clean and generally run on schedule in Japan. However, it is best to avoid
                    them during rush hour (7:30am – 9:30am and 5pm – 7pm) as they can become very crowded.</p>

                <h4 class="ttlSubSub">Taxis</h4>
                <p class="para">Japanese taxis are metered and provided you board one clearly labelled with the name of the
                    company the taxi belongs to, there is minimal risk of being defrauded. The price is determined
                    by the distance travelled and time taken, often increasing in the early morning and/or late at
                    night. Some taxi companies offer fixed prices for set routes, such as between the airport and
                    the city center. Traffic is on the left side of the road and therefore the steering wheel is on
                    the right side of the vehicle.</p>

                <h3 class="ttlSub" id="restaurants">Restaurants</h3>
                <p class="para">From Japanese to Western foods, Chinese or ethnic, there is a huge variety of foods available in
                    Japan’s major cities. There are also many different styles of restaurants to suit your needs,
                    from small family-run and local seafood restaurants to nationwide chains and three Michelin
                    starred restaurants. In less urban areas, local cuisine and standard Japanese food are often
                    most popular and readily available.<br>
                    Restaurants may not be able to accommodate dietary requirements such as those who have a Halal
                    or vegetarian diet so it is best to check with them beforehand.</p>

                <h3 class="ttlSub" id="additional-informationAdditional-information">Additional Information</h3>

                <h4 class="ttlSubSub">Consumption Tax</h4>
                <p class="para">The consumption tax for most purchases is 10%. Labels and price tags typically do not include the consumption tax so you will need to add 10% to know the final price.</p>

                <h4 class="ttlSubSub">Drinking Water</h4>
                <p class="para">Tap water is safe to drink throughout Japan unless otherwise stated.</p>

                <h4 class="ttlSubSub">Tipping</h4>
                <p class="para">In general, tipping is not necessary in Japan.</p>

                <h4 class="ttlSubSub">Electricity</h4>
                <p class="para">Sockets are usually 110 volts AC throughout Japan, 50Hz in the east and 60Hz in the west.</p>

                <h4 class="ttlSubSub">Currency</h4>
                <p class="para">Almost all major establishments such as hotels, airports, and department stores, as well as many large shops, accept credit cards (Visa, Diners, Mastercard, etc.) Smaller shops and restaurants typically do not accept card payment, so it is always better to have some cash with you, especially if you are not traveling with a tour group or are visiting areas outside of the major cities. Recently, electronic money has caught on in Japan, and are accepted at convenience stores and some shops. Foreign currency can also be exchanged in Japan.</p>

                <h4 class="ttlSubSub">Useful Links</h4>
                <p class="para">
                    Information about Japan: <a href="https://www.japan.travel/en/" target="_blank">https://www.japan.travel/en/</a><br>
                    Travel information: <a href="https://www.japan.travel/en/plan/">https://www.japan.travel/en/plan/</a><br>
                    Emergency Info: <a href="http://www.jnto.go.jp/eng/basic-info/index.html">http://www.jnto.go.jp/eng/basic-info/index.html</a></p>
            </div>
        </div>

        <div class="box-section">
            <div class="inner">
                <h2 class="ttl" id="goCulture">Going to See Cultural Properties</h2>

                <h3 class="ttlSub" id="things-to-be-aware-of">Things to Be Aware of</h3>
                <p class="para">Cultural Properties such as National Treasures preserve the regional culture and history, and are
                    therefore important to all of us. The local community takes great care of these artifacts and
                    sites so that it can preserved for everyone to enjoy.<br>
                    <br>
                    When you visit one of the Cultural Properties, please keep in mind the points below to ensure
                    your visits are trouble free:</p>

                <ul class="para">
                    <li>• Please do not disturb the local community.</li>
                    <li>• Do not enter private property without prior permission.</li>
                    <li>• Do not damage or pollute the Cultural Property.</li>
                    <li>• If the Cultural Property is privately owned, it may be closed to the public.</li>
                    <li>• If you would like to visit a privately-owned Cultural Property, please ask permission or apply for a permit in advance. If you would like to do a group visit, please contact the owner in advance.</li>
                    <li>• Ask for permission if you would like to take photographs.</li>
                    <li>• If the Cultural Property is owned by a temple, please check in advance for when it will be exhibited to the public.</li>
                    <li>• Temples and shrines are religious sites. There is a possibility that religious ceremonies are being conducted during your visit and that entry to certain areas are restricted.</li>
                    <li>• When you visit historic sites, ruins, or old tombs, do not take anything home with you.</li>
                    <li>• It is forbidden to smoke or light a fire at a Cultural Property or around the premises.</li>
                    <li>• Eating and drinking is not allowed.</li>
                    <li>• Take any trash home with you.</li>
                    <li>• Do not damage any plants nearby.</li>
                </ul>

                <h3 class="ttlSub" id="official-guides-and-volunteer-guides">Official Guides and Volunteer Guides</h3>
                <p class="para">To fully enjoy your visit, it might be a good idea to book an official guide. Official guides
                    have strong skills in at least one foreign language and in-depth knowledge of Japanese history,
                    geography, culture, and travelling in Japan. Guides are available in the following languages:
                    English, French, Spanish, German, Chinese, Italian, Portuguese, Russian, Korean, and Thai. They
                    can also provide assistance with visiting local sightseeing spots, organizing your schedule for
                    the duration of your visit, provide assistance with your accommodation, and provide advice for
                    the best places to shop. If you would like to book a guide, please inquire with travel agents or
                    through guiding associations.<br>
                    <br>
                    If you don’t need the full services of an official guide, you might want to ask for the help of
                    a volunteer guide. Volunteer guides are typically locals from the area you are visiting and will
                    welcome you with friendly, local hospitality. As they are not professional, official guides,
                    their services are low-cost or free. English is typically the spoken foreign language with
                    volunteer guides. If you would like to be shown around by a volunteer guide, please inquire at
                    the local tourist information center or at information desks at large sightseeing spots.</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HelpfulInfo",
        created: function() {
            document.title = 'Helpful Info | Japan Heritage Official Site'
        }
    }
</script>

<style src="./HelpfulInfo.scss" lang="scss" scoped/>
